 <template>
	<div>
	<!-- DIALOGS -->
		<SelectionRequiredDialog /> 
		<DeletionDialog :context="'Selected' + context" />	
        <!-- Import: Mapping import (dedicated dialog: preflight dry-run + confirmation) -->
        <MappingImportDialog
            v-if="getSelectedImportOption === 'mappingImport'"
            :alvqaContext="alvqa + '-list'"
            :domainConfig="worksMappingConfig"
        >
            <v-row>
                <v-col>
                    <BaseEditPageDropdown
                        field="ImportSelectedMapping"
                        :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                        :items="mappingAbbreviations"
                        :context="context"
                        rules="required"
                        :clearable="false"
                        :alvqa="alvqa + '-mapping-import-dropdown-select-abbreviation'"
                        :withMargin="false"
                    >
                    </BaseEditPageDropdown>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12">
                    <v-text-field
                        v-model="tagsForImport"
                        :label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
                        :alvqa="alvqa + '-mapping-import-textfield-tags'"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <BaseCheckbox
                        :context="context + 'DetailsSearchWorkByTitle'"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_MAPPING_IMPORT_RECOGNIZE_BY_WORK_TITLE')"
                        :value="false"
                        :alvqa="alvqa + '-mapping-import-recognize-works-by-work-title-checkbox'"
                    />
                </v-col>
            </v-row>
        </MappingImportDialog>

        <!-- Import: CWR / SUISA Worksfile (shared multi-purpose dialog) -->
        <FileImportDialog v-else :alvqaContext="alvqa +'-list'" :isUploadAllowed="isUploadAllowed">
			<template v-slot:importOptions>
                <v-row v-if="getSelectedImportOption === 'cwr'">
                    <v-col cols="4">
                        <BaseEditPageDropdown
                            field="ImportCwrType"
                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_CWR_TYPE')"
                            :items="getCwrTypes"
                            :context="context"
                            rules="required"
                            :clearable="false"
                            :alvqa="alvqa + '-cwr-import-dropdown-cwr-type'"
                            :withMargin="false"
                        >
                        </BaseEditPageDropdown>
                    </v-col>
                    <v-col cols="5">
                        <BaseEditPageDropdown
                            field="ImportCwrSourceShareType"
                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_CWR_SOURCE_SHARE_TYPE')"
                            :items="getCwrSourceShareTypes"
                            :context="context"
                            :rules="(getCwrImportType === 'ack' || getCwrImportType === null) ? '' : 'required'"
                            :clearable="false"
                            :alvqa="alvqa + '-cwr-import-dropdown-cwr-source-share-type'"
                            :withMargin="false"
                            :disabled="(getCwrImportType === 'ack' || getCwrImportType === null)"
                        >
                        </BaseEditPageDropdown>
                    </v-col>
                    <v-col cols="3">
                        <BaseEditPageDropdown
                            field="ImportCwrTargetShareType"
                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_CWR_TARGET_SHARE_TYPE')"
                            :items="getCwrTargetShareTypes"
                            :context="context"
                            :rules="(getCwrImportType === 'ack' || getCwrImportType === 'nonAckSociety' || getCwrImportType === null) ? '' : 'required'"
                            :clearable="false"
                            :alvqa="alvqa + '-cwr-import-dropdown-cwr-target-share-type'"
                            :withMargin="false"
                            :disabled="(getCwrImportType === 'ack' || getCwrImportType === null || getCwrImportType === 'nonAckSociety')"
                        >
                        </BaseEditPageDropdown>
                    </v-col>
                </v-row>
                <v-row v-if="getSelectedImportOption === 'cwr' && (getCwrImportType === 'nonAckPublisher' || getCwrImportType === 'nonAckSociety')">
                    <v-col>
                        <BaseEditPageAutocomplete
                            :context="context"
                            field="CwrPublisherSourceAz"
                            :label="$t(getCwrImportType === 'nonAckPublisher' ? 'lang_PUBLISHING_WORKS_CAPTION_FROM_PUBLISHER' : 'lang_PUBLISHING_WORKS_CAPTION_FROM_SOCIETY')"
                            rules="required"
                            :withFreeText="false"
                            :withMargin="false"
                            :clearable="false"
                            :alvqa="alvqa + '-cwr-import-autocomplete-source-publisher-textfield'"
                        >
                            <template v-slot:selection="{ item }">
                                <div class="ellipsis" :alvqa="alvqa + '-cwr-import-autocomplete-source-publisher-selection'">
                                    {{ getCwrImportType === 'nonAckPublisher' ? item.gemaName : item.name }}
                                    <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                    </span>
                                </div>
                            </template>
                            <template v-slot:items="{ items }">
                                <v-list-item-content :alvqa="alvqa + '-cwr-import-autocomplete-source-publisher-dropdown-' + items.alvId">
                                    <v-list-item-title :alvqa="alvqa + '-cwr-import-autocomplete-source-publisher-dropdown-' + items.alvId + '-title'">
                                        {{ getCwrImportType === 'nonAckPublisher' ? items.gemaName : items.name }}
                                        {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                    </v-list-item-title>
                                    <v-list-item-subtitle :alvqa="alvqa + '-cwr-import-autocomplete-source-publisher-dropdown-' + items.alvId + '-subtitle'">
                                        {{ items.alvId }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </BaseEditPageAutocomplete>
                    </v-col>
                </v-row>
				<v-row v-if="isCwrJsonImport">
					<v-col>
						<BaseEditPageAutocomplete
							:context="context"
							field="CwrPublisherSourceAz"
							:label="$t('lang_PUBLISHING_WORKS_CAPTION_FROM_PUBLISHER')"
							rules="required"
							:withFreeText="false"
							:withMargin="false"
							:clearable="false"
							:alvqa="alvqa + '-cwr-json-import-autocomplete-source-publisher-textfield'"
						>
							<template v-slot:selection="{ item }">
								<div class="ellipsis" :alvqa="alvqa + '-cwr-json-import-autocomplete-source-publisher-selection'">
									{{ item.gemaName }}
									<span v-if="$alvPlugin.printName(item)">
									({{ item.firstName }} {{ item.lastName }})
									</span>
								</div>
							</template>
							<template v-slot:items="{ items }">
								<v-list-item-content :alvqa="alvqa + '-cwr-json-import-autocomplete-source-publisher-dropdown-' + items.alvId">
									<v-list-item-title :alvqa="alvqa + '-cwr-json-import-autocomplete-source-publisher-dropdown-' + items.alvId + '-title'">
										{{ items.gemaName }}
										{{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}}
										<v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
									</v-list-item-title>
									<v-list-item-subtitle :alvqa="alvqa + '-cwr-json-import-autocomplete-source-publisher-dropdown-' + items.alvId + '-subtitle'">
										{{ items.alvId }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</template>
						</BaseEditPageAutocomplete>
					</v-col>
				</v-row>
				<v-row v-if="isCwrJsonImport">
					<v-col cols="4">
						<BaseEditPageDropdown
							context="WorksImportCwrJson"
							field="Schema"
							:items="cwrJsonSchemaItems"
							:label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CAPTION_TYPE_SCHEMA')"
							:selection="true"
							:withMargin="false"
							:clearable="false"
							:alvqa="alvqa + '-cwr-json-import-dropdown-schema'"
						/>
					</v-col>
					<v-col cols="8">
						<BaseRegions
							context="WorksImportCwrJson"
							includeLabel="lang_PUBLISHING_WORKS_EXPORT_INCLUDE_TERRITORY"
							excludeLabel="lang_PUBLISHING_WORKS_EXPORT_EXCLUDE_TERRITORY"
							cols="6"
							:withMargin="false"
							:alvqa="alvqa + '-cwr-json-import'"
						/>
					</v-col>
				</v-row>
				<v-row justify="center">
					<v-col cols="12">
						<v-text-field 
							v-model="tagsForImport"
							:label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
							:alvqa="alvqa + '-list-import-dialog-textfield-tags'"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row v-if="getSelectedImportOption === 'cwr' && (getCwrImportType === 'nonAckPublisher' || getCwrImportType === 'nonAckSociety')">
					<v-col cols="12">
						<BaseCheckbox
							:context="context + 'DetailsImportAllowed'"
							:required="getSelectedImportOption === 'cwr' && (getCwrImportType === 'nonAckPublisher' || getCwrImportType === 'nonAckSociety')"
							:label="$t('lang_PUBLISHING_WORKS_CAPTION_CONFIRM_UPLOAD_CWR_CHECKBOX')"
							:value="true"
							:alvqa="alvqa + '-cwr-import-confirm-upload-checkbox'"
						/>
					</v-col>
				</v-row>
				<v-row v-if="getSelectedImportOption === 'cwr'">
					<v-col cols="12">
						<v-alert
							type="info"
							dense
							text
							class="mb-0"
							:alvqa="alvqa + '-cwr-import-am-skip-info'"
						>
							{{ $t('lang_PUBLISHING_WORKS_CAPTION_CWR_IMPORT_AM_SKIPPED') }}
						</v-alert>
					</v-col>
				</v-row>
			</template>
		</FileImportDialog>
		<GemaSoundfileDialog />
		<WorksRegistrationDialog />
		<WorksBulkEditingDialog />
		<ManageTagsDialog 
			context="Works" 
			dir='publishing/works'
			idAttributeName='workIds'
		/>
		<DataSharingDialog domain="publishing_works" context="Works"/>
		<TestCalculationGemaDialog />
		<TestCalculationSvdDialog />
		<TestCalculationC3Dialog />
		<ExportWorksDialog />
		<ContextHelpDialog />
		<NoSharesDialog />
		<YearOfExpirationDialog />
		<FindDuplicatesDialog />
		<MergeWorksDialog />
        <DistributionSearchDialog />
		<ConfirmationDialog />
		<!-- Action: ADD CONTRACT(S) DIALOG -->
		<SearchDialog
			:context="context"
			:searchcontext="'ContractsFor' + context"
			subcontext="Contracts"
			:addcontext="'ContractsTo' + context"
			addButtonLabel="lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_BUTTON_ADD_WORKS"
			dialogTitle="lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_TITLE"
			:alvqaContext="alvqa + '-list'"
		>
			<!-- <template v-slot:selectAllText="{ items }">
				{{ contractsFoundSelectedText(items.items, items.selected) }}
			</template> -->

			<template v-slot:itemTitle="{ item }">
				{{ item.title }} ({{ item.alvId }})
			</template>
			<template v-slot:itemSubtitle="{ item }">
				{{ contractSubtitle(item) }}
			</template>
		</SearchDialog>

	<!-- LIST PAGE COMPONENT -->
		<BaseListPage
			headline="lang_PUBLISHING_CAPTION_WORKS"
			:context="context"
			:alvqa="alvqa"
			:stickyHeader="true"
		>
		<!-- FILTERS -->
		<!-- 
			Search-Textfield is already a part of the BaseListPage, 
			the base component will automatically add this search-field.
			Every other filter can be added in the filter slot.
		-->
			<template v-slot:filter>
				<!-- NEW help icon right next to the search field -->
				<v-col cols="auto" class="pl-0 ml-0 pt-6">
					<HelpIcon
						:urls="{
							de: '32735315',
							en: '51347577',
							ko: '98467850'
						}"
						:tooltipText="$t('lang_GENERIC_CLICK_TO_HELP_CENTER')"
					/>
				</v-col>
				<v-col cols="3">
					<DropdownFilter  
						:context="context + 'QualityFilter'"
						label="lang_PUBLISHING_WORKS_FILTER_CAPTION_QUALITY"
						:items="qualityItems"
						:alvqa="alvqa + '-list-dropdown-quality'"
						:additionalFunction="showAdditionalDialogs"
						runFunctionOnSameSelection
					/>
				</v-col>
				<v-col cols="3">
					<DropdownFilter 
						:context="context + 'StatusFilter'"
						label="lang_PUBLISHING_WORKS_FILTER_CAPTION_STATUS"
						:items="statusItems"
						:alvqa="alvqa + '-list-dropdown-status'"
					/>
				</v-col>

			</template>
		<!-- DATA TABLE COMPONENT -->
			<template v-slot:dataTable>
				<BaseDataTableList
					:headers="headers"
					:context="context"
					:alvqa="alvqa"
					:hasServerSideSorting='true'
					:stickyTopSlot="true"
				>	
				<!-- TOPSLOT: actions, imports etc. -->
					<template v-slot:topSlot="{ items }"><WorksTopSlot  :totalItems="items" /></template>
				<!-- DATA TABLE CONTENT: columns -->
					<template v-slot:body="{ item }">
						<ExpandIcon 
							:isExpanded="item.isExpanded" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
						/> 

						<!-- Type of Work, status=ghost or type=OPW / SPW / UPW or WORK  -->
						<td 
							v-if="isColumnVisible('lang_PUBLISHING_WORKS_CAPTION_TYPE')"
							class="caption text-center"
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-status-type'">
							{{ getWorksType(item) }}
						</td>					
						<td 
							v-if="isColumnVisible('lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE')"
							class="ellipsis">
							<BaseTooltip 
								:simpleText="item.item.title" 
								:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-work-title'"
							/>
						</td>
						<td 
							v-if="isColumnVisible('lang_PUBLISHING_WORKS_CAPTION_DOMESTIC_WORK_TITLE')"
							class="ellipsis">
							<BaseTooltip 
								:simpleText="item.item.domesticTitle || ''" 
								:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-domestic-work-title'"
							/>
						</td>
						<td 
							v-if="isColumnVisible('lang_PUBLISHING_CAPTION_COMPOSERS')"
							class="ellipsis">
							<BaseTooltip 
								:simpleText="formatDetailedNames(item.item.composersDetailed, item.item.composers, false)"
								:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-composers'"
							/>
						</td>						
						<td 
							v-if="isColumnVisible('lang_PUBLISHING_CAPTION_PUBLISHERS')"
							class="ellipsis">
							<BaseTooltip 
								:simpleText="formatDetailedNames(item.item.publishersDetailed, item.item.publishers, true)"
								:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-publishers'"
							/>
						</td>
						<td 
							v-if="isColumnVisible('lang_GENERIC_CAPTION_ISWC')"
							class="ellipsis">
							<BaseTooltip 
								:simpleText="item.item.iswc || ''"
								:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-iswc'"
							/>
						</td>
						<td 
							v-if="isColumnVisible('lang_PUBLISHING_WORKS_CAPTION_WORK_ID')"
							class="ellipsis text-right">
							<BaseTooltip 
								:simpleText="item.item.gemaNumber"
								:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-work-id'"
							/>
						</td>
						
						<!-- add Spotify link if setting set and CWR submitter code is present -->
						<td v-if="cwrSubmitterCode && spotifySetting" class="no_ellipsis"
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-alvid'"
						><a :href="spotifyUrl+cwrSubmitterCode+item.item.alvId" target="_blank">{{ item.item.alvId }}</a></td>
						
						<td v-else class="no_ellipsis"
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-alvid'"
						>{{ item.item.alvId }}</td>

					</template>
				<!-- EXPAND: Read Only View -->
					<template v-slot:expandSlot="{ id }"><WorkReadOnly :itemId='id' /></template>
				</BaseDataTableList>
			</template>	
		</BaseListPage>				
	</div> 	
</template>

<script>
import { mapGetters } from 'vuex'
import { isListColumnVisible } from '@/utils/listColumnSettings'

import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseListPage from '@/components/_base/BaseListPage'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseCheckbox from '@/components/_base/BaseCheckbox'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

import WorksTopSlot from './WorksTopSlot'
import WorkReadOnly from './_readonly/WorkReadOnly'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import DropdownFilter from '@/components/_filters/DropdownFilter'

import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import FileImportDialog from '@/components/_dialogs/FileImportDialog'
import MappingImportDialog from '@/components/_dialogs/MappingImportDialog'
import { mappingImportConfigs } from '@/components/_dialogs/mappingImportConfigs'
import SearchDialog from '@/components/_dialogs/SearchDialog'
import GemaSoundfileDialog from './_dialogs/GemaSoundfileDialog'
import ManageTagsDialog from '@/components/_dialogs/ManageTagsDialog'
import TestCalculationGemaDialog from './_dialogs/TestCalculationGemaDialog'
import TestCalculationSvdDialog from './_dialogs/TestCalculationSvdDialog'
import TestCalculationC3Dialog from './_dialogs/TestCalculationC3Dialog'
import ExportWorksDialog from './_dialogs/ExportWorksDialog'
import NoSharesDialog from './_dialogs/NoSharesDialog'
import DistributionSearchDialog from './_dialogs/DistributionSearchDialog'
import WorksRegistrationDialog from './_dialogs/WorksRegistrationDialog'
import WorksBulkEditingDialog from './_dialogs/WorksBulkEditingDialog'
import YearOfExpirationDialog from './_dialogs/YearOfExpirationDialog.vue'
import FindDuplicatesDialog from './_dialogs/FindDuplicatesDialog.vue'
import MergeWorksDialog from './_dialogs/MergeWorksDialog.vue'
import BaseEditPageAutocomplete from "@/components/_editForm/BaseEditPageAutocomplete.vue";
import BaseRegions from '@/components/_base/BaseRegions'
import ConfirmationDialog from '@/components/_dialogs/ConfirmationDialog.vue'
import ContextHelpDialog from '@/components/_dialogs/ContextHelpDialog'
import HelpIcon from '@/components/_buttons/HelpIcon'
import DataSharingDialog from '@/components/_dialogs/DataSharingDialog.vue'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'

export default {
	name: 'WorksList',						
	components: {
        BaseEditPageAutocomplete,
		BaseRegions,
		HelpIcon,
		ContextHelpIcon,
		BaseListPage,
		BaseDataTableList,
		BaseTooltip,
		BaseCheckbox,
		BaseEditPageDropdown,
		WorksTopSlot,
		WorkReadOnly,
		ExpandIcon,
		DropdownFilter,
		SelectionRequiredDialog,
		DeletionDialog,
		FileImportDialog,
		MappingImportDialog,
		NoSharesDialog,
        DistributionSearchDialog,
		SearchDialog,
		GemaSoundfileDialog,
		ManageTagsDialog,
		DataSharingDialog,
		TestCalculationGemaDialog,
		TestCalculationSvdDialog,
        TestCalculationC3Dialog,
		ExportWorksDialog,
		ContextHelpDialog,
		WorksRegistrationDialog,
		WorksBulkEditingDialog,
    	YearOfExpirationDialog,
    	FindDuplicatesDialog,
    	MergeWorksDialog,
		ConfirmationDialog
},
	data() {
		return {
			context: "Works",
			alvqa: 'publishing-works',
			spotifyUrl: "https://works.spotify.com/work/",
		}
	},
	computed: {
		...mapGetters(['getWorksSearch', 'getSelectedWorksQualityFilter', 'getSelectedWorksStatusFilter', 'getPublishingSettings']),
		
		// Returns an Array with header-objects with props.
		headers() {
			// Fixed headers that are always visible
			const fixedStartHeaders = [		
				{
					text: '', 
					value: 'data-table-select', 
					align: 'center',
					width: "60px",
					sortable: false,
					class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
					width: "48px",
					sortable: false,
					class: 'text-no-wrap'
				}
			];

			// Configurable headers with their setting keys
			const configurableHeaders = [
				{
					text: '', 
					value: 'type', 
					align: 'center', 
					sortable: false, 
					width: "80px",
					class: 'text-no-wrap',
					settingKey: 'lang_PUBLISHING_WORKS_CAPTION_TYPE'
				},	
				{
					text: this.$t('lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE'), 
					value: 'title', 
					align: 'left', 
					sortable: true,
					class: 'text-no-wrap',
					settingKey: 'lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_CAPTION_DOMESTIC_WORK_TITLE'), 
					value: 'domesticTitle', 
					align: 'left', 
					sortable: true,
					class: 'text-no-wrap',
					settingKey: 'lang_PUBLISHING_WORKS_CAPTION_DOMESTIC_WORK_TITLE'
				}, 
				{
					text: this.$t('lang_PUBLISHING_CAPTION_COMPOSERS'), 
					value: 'composers', 
					align: 'left', 
					sortable: false,
					class: 'text-no-wrap',
					settingKey: 'lang_PUBLISHING_CAPTION_COMPOSERS'
				},
				{
					text: this.$t('lang_PUBLISHING_CAPTION_PUBLISHERS'), 
					value: 'publishers',
					align: 'left', 
					sortable: false,
					class: 'text-no-wrap',
					settingKey: 'lang_PUBLISHING_CAPTION_PUBLISHERS'
				},
				{
					text: this.$t('lang_GENERIC_CAPTION_ISWC'), 
					value: 'iswc', 
					align: 'left', 
					sortable: true,
					class: 'text-no-wrap',
					settingKey: 'lang_GENERIC_CAPTION_ISWC'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_CAPTION_WORK_ID'), 
					value: 'gemaNumber', 
					align: 'end', 
					sortable: true,
					width: "140px",
					class: 'text-no-wrap',
					settingKey: 'lang_PUBLISHING_WORKS_CAPTION_WORK_ID'
				}
			];

			// Fixed end headers that are always visible
			const fixedEndHeaders = [			
				{
					text: this.$t('lang_CAPTION_ALVID'),
					value: 'alvId', 
					align: 'left', 
					sortable: true,
					width: "170px",
					class: 'text-no-wrap'
				}, 
				{
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
					width: "70px",
					class: 'text-no-wrap'
				}
			];

			// Filter configurable headers based on settings
			const visibleConfigurableHeaders = configurableHeaders.filter(header => {
				if (!header.settingKey) return true; // Always show if no setting key
				
				return this.isColumnVisible(header.settingKey);
			});

			return [...fixedStartHeaders, ...visibleConfigurableHeaders, ...fixedEndHeaders];
		},
		qualityItems() {
            return [
                {
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_NO_CONTRACT'), 
					value: 'noContract',
					alvqa: this.alvqa + '-list-dropdown-quality-no-contracts-connected'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_CAPTION_QA_FILTER_NO_SHEET_CONNECTED'),
					value: 'noSheets',
					alvqa: this.alvqa + '-list-dropdown-quality-no-sheet-connected'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_NO_UVZ'),
					value: 'noUVZ',
					alvqa: this.alvqa + '-list-dropdown-quality-without-uvz'
				},
				{
					text: this.$t('lang_GENERIC_CAPTION_YEAR_OF_EXPIRATION'),
					value: 'yearOfExpiration',
					alvqa: this.alvqa + '-list-dropdown-quality-year-of-expiration'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_NO_UVZ_OF_CONTRACTING_PARTY'),
					value: 'noUvzOfContractingParty',
					alvqa: this.alvqa + '-list-dropdown-quality-no-uvz-of-contracting-party'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_WITH_CONTRACT_CHAINS'),
					value: 'withContractChains',
					alvqa: this.alvqa + '-list-dropdown-quality-with-contract-chains'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_CAPTION_DISTRIBUTION_SEARCH'),
					value: 'distributionSearch',
					alvqa: this.alvqa + '-list-dropdown-quality-distribution-search'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_SHARES_SUM_MORE_THAN_100'), 
					value: '100Share',
					alvqa: this.alvqa + '-list-dropdown-quality-shares-more-than-100'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_SHARES_SUM_LESS_THAN_100'), 
					value: 'lessThan100Share',
					alvqa: this.alvqa + '-list-dropdown-quality-shares-less-than-100'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_SHARES_EMPTY'), 
					value: 'noShare',
					alvqa: this.alvqa + '-list-dropdown-quality-no-shares'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_SHARES_SUM_0'), 
					value: '0Share',
					alvqa: this.alvqa + '-list-dropdown-quality-shares-sum-0'
				},
				// {
				// 	text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_NEGATIVE_SHARES'), 
				// 	value: 'negativeShares',
				// 	alvqa: this.alvqa + '-list-dropdown-quality-negative-shares'
				// },
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_NO_TRACK'), 
					value: 'noTrack',
					alvqa: this.alvqa + '-list-dropdown-quality-no-track-connection'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_OLD_GEMA_SPLIT'), 
					value: 'oldGemaSplit',
					alvqa: this.alvqa + '-list-dropdown-quality-old-gema-split'
				},
				{
					text: this.$t('lang_GENERIC_CAPTION_FIND_DUPLICATES'),
					value: 'duplicates',
					alvqa: this.alvqa + '-list-dropdown-quality-duplicates'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_NO_TYPE'), 
					value: 'noType',
					alvqa: this.alvqa + '-list-dropdown-quality-no-work-type'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_QA_FILTER_OPTION_NO_ISRC'), 
					value: 'noIsrc',
					alvqa: this.alvqa + '-list-dropdown-quality-no-isrc'
				},
            ]
		},
		statusItems() {
			return [
				{
					text: this.$t('lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_REGISTERED_WORKS'), 
					value: 'registered',
					alvqa: this.alvqa + '-list-dropdown-status-registered'
				},	
				{
					text: this.$t('lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_GEMA_STATUS_2'), 
					value: 'status2',
					alvqa: this.alvqa + '-list-dropdown-status-status-2'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_GHOST_WORKS'), 
					value: 'ghost',
					alvqa: this.alvqa + '-list-dropdown-status-ghost'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_WITHOUT_GHOST_WORKS'), 
					value: 'withoutGhost',
					alvqa: this.alvqa + '-list-dropdown-status-without-ghost'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_CAPTION_TO_BE_UPDATED'), 
					value: 'update',
					alvqa: this.alvqa + '-list-dropdown-status-update'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_REGISTER_NEW_OVW'), 
					value: 'newOpw',
					alvqa: this.alvqa + '-list-dropdown-new-opw'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_REGISTER_NEW_SVW'), 
					value: 'newSpw',
					alvqa: this.alvqa + '-list-dropdown-status-new-spw'
				},
				{
					text: this.$t('lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_OPW_REGISTRATION'), 
					value: 'inRegistrationOpw',
					alvqa: this.alvqa + '-list-dropdown-status-in-registration-opw'
				}, 
				{
					text: this.$t('lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_SPW_REGISTRATION'), 
					value: 'inRegistrationSpw',
					alvqa: this.alvqa + '-list-dropdown-status-in-registration-spw'
				}
			]
		},
	getCwrTypes() {
		let alvQaBase = this.alvqa + '-cwr-import-dropdown-cwr-type'
		return [
			{
				text: 'lang_PUBLISHING_WORKS_BUTTON_OPTION_CWR_IMPORT', 
				value: 'ack',
				alvqa: alvQaBase + '-ack'
			},
			{
				text: 'lang_PUBLISHING_WORKS_CAPTION_CWR_NON_ACK_PUBLISHER', 
				value: 'nonAckPublisher',
				alvqa: alvQaBase + '-non-ack-publisher'
			},
			{
				text: 'lang_PUBLISHING_WORKS_CAPTION_CWR_NON_ACK_SOCIETY',
				value: 'nonAckSociety',
				alvqa: alvQaBase + '-non-ack-society'
			},
			{
				text: 'lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CAPTION_TYPE_JSON',
				value: 'cwrJson',
				alvqa: alvQaBase + '-cwr-json'
			}
		]
	},
		getCwrSourceShareTypes() {
			let alvQaBase = this.alvqa + '-cwr-import-dropdown-cwr-source-share-type'
			return [
				{
					text: 'lang_PUBLISHING_WORKS_CAPTION_CWR_OWNERSHIP', 
					value: 'ownership',
					alvqa: alvQaBase + '-ownership'
				}, 
				{
					text: 'lang_PUBLISHING_WORKS_CAPTION_CWR_COLLECTION', 
					value: 'collection',
					alvqa: alvQaBase + '-collection'
				}
			]
		},
		getCwrTargetShareTypes() {
			let alvQaBase = this.alvqa + '-cwr-import-dropdown-cwr-target-share-type'
			return [
				{
					text: 'lang_GENERAL_INTL_PERCENT', 
					value: 'intl',
					alvqa: alvQaBase + '-intl'
				}, 
				{
					text: 'lang_GENERIC_CAPTION_OWN_PERCENT', 
					value: 'own',
					alvqa: alvQaBase + '-own'
				}
			]
		},
		tagsForImport: {
			get() { return this.$store.getters.getWorkImportTags },
			set(tags) { this.$store.commit('setWorkImportTags', tags) }
		},
		cwrSubmitterCode() {
			return this.$store.getters.getSelectedCwrSubmitterCode
		},
		spotifySetting() {
			return this.$store.getters.getSelectedSpotifySetting
		},
		getSelectedImportOption() {
			return this.$store.getters.getSelectedFileImport
		},
        getCwrImportType() {
            let type = this.$store.getters.getWorksDetailsImportCwrType
            if (type === 'ack') {
                this.$store.commit('setWorksDetailsCwrPublisherSourceAz', null)
                this.$store.commit('setWorksDetailsImportCwrSourceShareType', null)
                this.$store.commit('setWorksDetailsImportCwrTargetShareType', null)
            }

            return type
        },
        isCwrJsonImport() {
            return this.getSelectedImportOption === 'cwrJson' || (this.getSelectedImportOption === 'cwr' && this.getCwrImportType === 'cwrJson')
        },
		isMappingImport() {
			return this.getSelectedImportOption === 'mappingImport';
		},
		cwrJsonSchemaItems() {
			return [{
				text: 'CWR-JSON v1.0 Schema',
				value: 'cwr-json-v1.0',
				alvqa: this.alvqa + '-cwr-json-import-schema-v1-0'
			}]
		},
		// Domain config that drives the reusable MappingImportDialog for Works.
		worksMappingConfig() {
			return mappingImportConfigs.Works;
		},
		mappingAbbreviations() {
			let mappingsList = this.$store.getters.getMappings
            let retArr = []
            mappingsList.forEach((v) => {
				if (v.direction !== 'import') return;

                retArr.push({
                    value: v.alvId,
                    text: v.abbreviation,
                    alvqa: this.alvqa + `-import-mapping-${v.alvId}`,
					disabled: v.columnMappingsCount === 0, // Disable if no column mappings exist for this mapping
                })
            })
			   // Sort by ALVID descending (highest first)
			   retArr.sort((a, b) => {
				   if (a.disabled === true) return 1; // Put disabled at the end
                   if (b.disabled === true) return -1;
			       const alvIdA = parseInt(a.value.replace(/\D/g, '')) || 0
			       const alvIdB = parseInt(b.value.replace(/\D/g, '')) || 0
			       return alvIdB - alvIdA
			   })
			   // Side-effect intentionally contained in WorksList (avoid watchers/actions changes):
			   // 1) Auto-select first mapping if none selected or selection invalid
			   if (this.isMappingImport && retArr.length > 0) {
			       const selected = this.$store.getters.getWorksDetailsImportSelectedMapping
			       const found = retArr.find(o => o.value === selected)
			       if ((selected === null || selected === undefined || !found) && retArr[0].disabled === false) {
			           this.$store.commit('setWorksDetailsImportSelectedMapping', retArr[0].value)
			       }
			   }
			// 2) Show red warning when no mappings available (only after loading finishes)
			if (this.isMappingImport && retArr.length === 0 && this.$store.getters.getIsLoading === false) {
			       const warn = this.$t('lang_GENERIC_MESSAGE_WARNING_NO_MAPPINGS_AVAILABLE_FOR_DOMAIN')
			       this.$store.commit('setImportDialogText', `<span class="error--text">${warn}</span>`)
			   }
			return retArr
		},
		isUploadAllowed() {
			if (this.isCwrJsonImport) {
				return !!this.$store.getters.getWorksDetailsCwrPublisherSourceAz
			}
			if (this.getSelectedImportOption === 'cwr' && (this.getCwrImportType === 'nonAckPublisher' || this.getCwrImportType === 'nonAckSociety')) {
				return this.$store.getters.getWorksDetailsImportAllowedCheckbox;
			}
			return true;
		}
	},
	methods: {
		formatDetailedNames(detailed, fallback, isPublisher) {
			if (!detailed || detailed.length === 0) {
				return fallback ? fallback.join(' / ') : '';
			}
			const LATIN_ONLY = /^[\u0000-\u024F\u1E00-\u1EFF\u2000-\u206F\u20A0-\u20CF\u2100-\u214F\s\d\p{P}]*$/u;
			return detailed.map(d => {
				if (isPublisher) {
					if (d.group && d.group !== '' && !LATIN_ONLY.test(d.group)) {
						return d.group;
					}
					return d.key;
				}
				if (d.last !== null && d.last !== '' && d.first !== null && d.first !== '') {
					const nameStr = d.last + d.first;
					if (!LATIN_ONLY.test(nameStr) || this.$i18n.locale === 'ja' || this.$i18n.locale === 'ko') {
						const hasNonLatin = !LATIN_ONLY.test(nameStr);
						const space = hasNonLatin ? '\u3000' : ' ';
						return d.last + space + d.first;
					}
					return d.first + ' ' + d.last;
				}
				return d.key;
			}).join(' / ');
		},
		/**
		 * Check if a column should be visible based on settings
		 * @param {string} settingKey - The option1 value from alv_settings that identifies this column
		 * @returns {boolean} - Whether the column should be visible
		 */
		isColumnVisible(settingKey) {
			// The duplicate value has to be on screen, otherwise the filter result is not verifiable
			if (settingKey === 'lang_GENERIC_CAPTION_ISWC'
				&& this.$store.getters.getSelectedWorksQualityFilter === 'duplicates'
				&& this.$store.getters.getSelectedDuplicatesIdType === 'iswc') {
				return true;
			}

			if (settingKey === 'lang_PUBLISHING_CAPTION_COMPOSERS'
				&& this.$store.getters.getSelectedWorksQualityFilter === 'duplicates'
				&& this.$store.getters.getSelectedDuplicatesIdType === 'titleComposer') {
				return true;
			}

			return isListColumnVisible(
				this.getPublishingSettings,
				'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_WORKS',
				'lang_SETTINGS_PUBLISHING_WORKS_LISTPAGE',
				settingKey
			);
		},
		showAdditionalDialogs(){
			let option = this.$store.getters.getSelectedWorksQualityFilter
			let qaOptions = ["lessThan100Share", "100Share", "noUVZ", "withContractChains", "0Share", "noUvzOfContractingParty"]
			if (option === "noShare") {
				this.$store.commit('setNoSharesCheckbox',["role"])
				this.$store.commit('setShowNoSharesDialog', true)
			} 
            else if (qaOptions.includes(option)) {
				this.$store.commit('setNoSharesCheckbox',[])
				this.$store.commit('setNoSharesHomeSocietyCheckbox',[])
				this.$store.commit('setShowNoSharesDialog', true)
            } 
            else if (option === "distributionSearch") {
				this.$store.commit('setShowDistributionSearchDialog', true)
            }
			else if (option === "yearOfExpiration") {
				this.$store.commit('setShowYearOfExpirationDialog', true)
			} 
			else if (option === "duplicates") {
				this.$store.commit('setShowFindDuplicatesDialog', true)
			}
            else {
				this.$store.commit('setNoSharesCheckbox',['role'])
			}
		},	
		/** Generates the text for the Search Dialog.
		 *  Depending on how many contracts are found and selected for adding to work(s).
		 *  @param {[]} contracts found contracts
		 *  @param {[]} selected selected contracts
		 *  @return {String}
		 */
		contractsFoundSelectedText(contracts, selected) {
            let text = contracts.length + ' '

			if(contracts.length === 0) {
				text += this.$t('lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_CONTRACTS_FOUND')
				return text
			}

            if(contracts.length === 1) text += this.$t('lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_CONTRACT_FOUND')
            else text += this.$t('lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_CONTRACTS_FOUND')

            text += ', ' + selected.length + ' '

            if(selected.length === 1) text += this.$t('lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_CONTRACT_SELECTED') 
            else text += this.$t('lang_PUBLISHING_WORKS_ADD_CONTRACTS_DIALOG_CONTRACTS_SELECTED') 
            
            return text			
		},
		contractSubtitle(contract) {
			const parts = []
			if(contract.licensor) parts.push(contract.licensor.gemaName)

			const contractType = contract.contractType || (contract.mainContract ? contract.mainContract.contractType : null)
			if(contractType) parts.push(contractType)

			const worksNum = Number(contract.numberOfAssignedWorks) || 0
			parts.push(this.$t('lang_GENERIC_CAPTION_NUMBER_OF_WORKS') + ': ' + this.$n(worksNum, 'numberInteger'))

			return parts.join(' · ')
		},
		getWorksType(item) {
			switch (item.item.type) {
				case 'opw':
					return this.$t("lang_PUBLISHING_WORKS_DROPDOWN_TYPE_OPW")
				case 'spw':
					return this.$t("lang_PUBLISHING_WORKS_DROPDOWN_TYPE_SPW")
				case 'upw':
					// return this.$t("lang_PUBLISHING_WORKS_DROPDOWN_TYPE_UPW") + ' (' + this.$t('lang_GENERAL_GHOST') + ')'
					return this.$t("lang_PUBLISHING_WORKS_DROPDOWN_TYPE_UPW")
				default:
					return this.$t("lang_GENERAL_WORK")
			}
		},
		getMappings() {
			// Clear mappings list, prevent a bug in the following scenario:
			// user switches quickly from account > mappings (eg. filtered by maintainer) to publishing works
			// And before 'fetchMappingsByDomain' is executed it will display previous list from account > mappings in export dialog
			this.$store.commit('setMappings', [])
            this.$store.commit('setSelectedMappingsDomainsFilter', 'publishing_works')
            this.$store.dispatch('fetchMappingsByDomain')
		},
	},
	watch: {
		getCwrImportType: function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.$store.commit('setWorksCwrPublisherSourceAzOptions', [])
				this.$store.commit('setWorksDetailsImportAllowedCheckbox', false)
			}
		}
	},
	created() {		
		this.$store.commit('setSelectedWorksAction', [])
		this.$store.dispatch('fetchCwrSubmitterCode')
		this.$store.dispatch('fetchSlgContracts')
		this.getMappings()
		// Load settings for column visibility
		this.$store.dispatch('fetchPublishingSettings')
	},
}
</script>